import { createAuthFromRuntimeConfig } from "@fox1ck-org/auth";
import { useAuth } from "@fox1ck-org/auth/react";

import { runtimeConfig } from "@/lib/runtime-config";

// One auth core for the SPA: Keycloak PKCE, realm `vibe`, client
// `vibe-platform`. The core finishes the return on /callback before the first
// render and puts back the address the person started from: there is no
// callback route. `groups` stays in the scope: the gateway projects that claim
// into X-Identity-Groups.
export const auth = createAuthFromRuntimeConfig(runtimeConfig, {
  scope: "openid profile email groups organization",
  callbackPath: "/callback",
});

export function getAccessToken(): Promise<string | null> {
  return auth.getAccessToken();
}

// Mirrors the API-side rbac.ts exactly: permission is the CLIENT role, which
// is what this dashboard assigns on the app roles screen. Realm roles and KC
// groups are org identity and grant nothing here, so the package's realm-role
// `isPlatformAdmin` is not this signal.
export function useIsPlatformAdmin(): boolean {
  return useAuth().hasRole("platform-admin");
}

export function getKeycloakImpersonationUrl(userId: string): string {
  const origin = new URL(runtimeConfig.keycloakIssuer).origin;
  return `${origin}/admin/master/console/#/vibe/users/${userId}`;
}
